module.exports = __webpack_public_path__ + "img/4.edec1f72.png";